module.exports = __webpack_public_path__ + "img/bing_1.fd0ee210.png";